/* RESPONSIBLE TEAM: team-standalone */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import type Model from '@ember-data/model';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import { taskFor } from 'ember-concurrency-ts';
import type HandoffToExternalTicketOnResolutionData from 'embercom/models/operator/fin/handoff-to-external-ticket-on-resolution-data';

export default class HandoffToExternalTicketOnResolutionDataValid extends BaseValidator {
  @service declare intl: IntlService;

  async validate(
    _value: unknown,
    _options: ValidationOptions,
    model: Model & {
      app: any;
      handoffToExternalTicketOnResolutionData: HandoffToExternalTicketOnResolutionData | undefined;
      finStandaloneService: FinStandaloneService;
    },
  ) {
    if (
      !model.app.isStandaloneApp ||
      !model.app.hasStandalonePlatform('salesforce') ||
      !model.handoffToExternalTicketOnResolutionData?.handoffEnabled
    ) {
      return true;
    }

    if (model.handoffToExternalTicketOnResolutionData.handoffToSalesforceOwnerId) {
      await this.waitForSalesforceSetupData(model.finStandaloneService);
      let { admins = [], queues = [] } = model.finStandaloneService.salesforceSetupData;
      let handOffOptions = [...admins.mapBy('id'), ...queues.mapBy('id')];
      if (
        handOffOptions.includes(
          model.handoffToExternalTicketOnResolutionData.handoffToSalesforceOwnerId,
        )
      ) {
        return true;
      }
    }

    return this.intl.t(
      'operator.workflows.visual-builder.handoff-to-external-ticket-on-resolution.salesforce.invalid-handoff-owner-id',
    );
  }

  static getDependentsFor() {
    return [
      'model.app.isStandaloneApp',
      'model.app.standalone_platforms',
      'model.handoffToExternalTicketOnResolutionData.handoffEnabled',
      'model.handoffToExternalTicketOnResolutionData.handoffToSalesforceOwnerId',
      'model.finStandaloneService.salesforceSetupData',
    ];
  }

  async waitForSalesforceSetupData(finStandaloneService: FinStandaloneService) {
    // This works under the assumption that the salesforce setup data is loaded or loading.
    // As part of initializing the finStandaloneService.
    if (!taskFor(finStandaloneService.loadSalesforceSetupData).isRunning) {
      return;
    }

    return taskFor(finStandaloneService.loadSalesforceSetupData).last!;
  }
}
